import { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../../packages/ui/src/auth';
import { LanguageProvider } from '../../../packages/ui/src/i18n';
import '../../../packages/ui/src/styles.css';

// Keep the staff shell, editors and sign-in code outside the guest loading path.
const StaffApp = lazy(() => import('./StaffApp'));
const PublicBooking = lazy(() =>
  import('./hotel/PublicBooking').then((m) => ({ default: m.PublicBooking })),
);
const bookingSlug = /^\/book\/([^/]+)\/?$/.exec(location.pathname)?.[1];
const chatSlug = /^\/chat\/([^/]+)\/?$/.exec(location.pathname)?.[1];
const PublicAssistant = lazy(() =>
  import('./hotel/PublicAssistant').then((m) => ({ default: m.PublicAssistant })),
);
const loading = (
  <main className="booking-public-message" aria-busy="true">
    LFB…
  </main>
);
createRoot(document.getElementById('root')!).render(
  <Suspense fallback={loading}>
    {bookingSlug || chatSlug ? (
      <QueryClientProvider client={queryClient}>
        <LanguageProvider persist={false}>
          {bookingSlug ? (
            <PublicBooking slug={decodeURIComponent(bookingSlug)} />
          ) : (
            <PublicAssistant slug={decodeURIComponent(chatSlug!)} />
          )}
        </LanguageProvider>
      </QueryClientProvider>
    ) : (
      <StaffApp />
    )}
  </Suspense>,
);
